import { render } from "./LedgerTableShort.vue?vue&type=template&id=144ffaa1&scoped=true"
import script from "./LedgerTableShort.vue?vue&type=script&lang=js"
export * from "./LedgerTableShort.vue?vue&type=script&lang=js"

import "./LedgerTableShort.vue?vue&type=style&index=0&id=144ffaa1&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144ffaa1"]])

export default __exports__